export default import.meta.ROLLDOWN_FILE_URL_E61uw0pKteaGDjASw1dqSA